// Intel input component
const IntelInput = () => {
    // Selecting element
    const input = document.querySelector("#phone");

    // Return if input not exist
    if (!input) return;

    // Init input
    const intl = window.intlTelInput(input, {
        initialCountry: "ae",
        countrySearch: false,
        separateDialCode: true,
        hiddenInput: () => ({ 
            phone: "full_phone", 
            country: "country_code" 
        }),
        loadUtils: () => import("../vendor/intel-utils.min"),
    });

    // Method to handle field input
    const updateField = () => {
        // Getting number
        const fullPhone = intl.getNumber();

        // Getting hidden field
        const hiddenInput = input
                .closest("form")
                .querySelector('[name="full_phone"]');

        // Update the value
        hiddenInput.value = fullPhone;
    }

    // Adding input event on phone field
    input.addEventListener('input', updateField);
    input.addEventListener("countrychange", updateField);
};

// Export component
export default IntelInput;